import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import cauzenlogo from '../assest/CauZen Logo 01.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const scrollToSection1 = (sectionId) => {
    closeMenu(); // close menu on link click
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav id="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <img src={cauzenlogo} alt="logo" onClick={() => scrollToSection1('Home')} />
          <h1 onClick={() => scrollToSection1('Home')}>CauZen</h1>

          <div className="hamburger" onClick={toggleMenu}>
            <span className={menuOpen ? 'open' : ''}></span>
            <span className={menuOpen ? 'open' : ''}></span>
            <span className={menuOpen ? 'open' : ''}></span>
          </div>
        </div>

        <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <ul>
            <li onClick={() => scrollToSection1("Home")}>Home</li>
            <li onClick={() => scrollToSection1("about")}>About</li>
            <li onClick={() => scrollToSection1("solution")}>Solution</li>
            <li onClick={() => scrollToSection1("contact")}>Contact</li>
            <li onClick={() => scrollToSection1("gallery")}>Solution Gallery</li>
            <li onClick={() => scrollToSection1("Careers")}>Careers</li>
          </ul>
          <button className="navbar-btn" onClick={() => scrollToSection1("contact")}>
            Get Started <span className="arrow"><i className="fas fa-arrow-right"></i></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
